﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:ForecastScenarioController
 * @description
 * # ForecastScenarioController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('ForecastScenarioController', ['$scope', '$rootScope', '$timeout', 'ForecastService', '$q', '$location', '$routeParams', 'ScenarioForecast', 'StaffInfo', 'Constants', 'FlashService', 'ForecastConfirmationService', 'CensusProjection', 'AttendanceProjection', 'AttendanceReport', 'StaffSchedulesDragAndDropActions', 'RoomSchedulesDragAndDropActions', 'ScenarioChangesBridge', 'ActivityUtils',
      function ($scope, $rootScope, $timeout, ForecastService, $q, $location, $routeParams, ScenarioForecast, StaffInfo, Constants, FlashService, ForecastConfirmationService, CensusProjection, AttendanceProjection, AttendanceReport, StaffSchedulesDragAndDropActions, RoomSchedulesDragAndDropActions, ScenarioChangesBridge, ActivityUtils) {

          $scope.staffScenario = true;
          $scope.header = {};
          $scope.selectedWeekChanged = {};
          $scope.newWeek = 0;
          $scope.showAnUssignedActivitiesPane = true;
          $scope.showAttendanceReports = true;

          $scope.Forecast = new ScenarioForecast(Constants.ForecastMode.Scenario);
          $scope.StaffInfo = new StaffInfo();
          $scope.Census = new CensusProjection();
          $scope.AttendanceProjection = new AttendanceProjection();
          $scope.AttendanceReport = new AttendanceReport();

          $scope.StaffSchedulesDragging = new StaffSchedulesDragAndDropActions($scope.Forecast.StaffSchedules, parseInt($routeParams.scenarioId));
          $scope.RoomSchedulesDragging = new RoomSchedulesDragAndDropActions($scope.Forecast.RoomSchedules);

          $scope.forms = {};
          $scope.notes = {};

          $scope.showStaffSchedule = true;

          $scope.attendanceTooltip = 'View staff attendance and add/remove staff PTO';
          $scope.censusTooltip = 'View projected census and change rack census projections';
          $scope.applyScenarioTooltip = 'Click Apply Scenario to make all scheduling, attendance, and census changes in this scenario permanent';

          $scope.selectedScenarioId = sessionStorage.scenarioId = parseInt($routeParams.scenarioId);

          var UnAssignActivityAction = { icon: 'general-user-minus-16px.svg', name: 'Un-assign activity', value: 0 };
          var ReturnToOriginalStaffAction = { icon: 'general-return-circle.svg', name: 'Return to Original Staff', value: 3 };
          var CancelActivityAction = { icon: 'general-trash-16px.svg', name: 'Cancel activity', value: 1 };

          $scope.setCurrentWeek = function (id) {
              confirmLocationChange(null,
                      function () {
                          $scope.weeks.forEach(function (item) {
                              if (item.week === id) {
                                  sessionStorage.week = id;
                                  $scope.selectedWeek = item;
                              }
                          });
                          $scope.Forecast.loadSchedulesHeaders($scope.header, $scope.selectedWeek);
                          loadRightPanes($scope.header, $scope.selectedWeek);
                          $scope.Census.load($scope.header, $scope.selectedWeek, $scope.selectedScenario.id, Constants.ForecastMode.Scenario);
                          $scope.AttendanceProjection.load($scope.header, $scope.selectedWeek, $scope.selectedScenario.id, Constants.ForecastMode.Scenario);
                      });
          };

          $scope.changeForecastScope = function (scope) {

              confirmLocationChange(null, function () {
                  if ($scope.header.selectedForecastScope.id !== scope.id) {
                      $scope.header.selectedForecastScope = scope;
                      sessionStorage.selectedForecastScopeId = scope.id;
                      sessionStorage.selectedForecastScopeValue = scope.value;
                      $scope.Forecast.loadSchedulesHeaders($scope.header, $scope.selectedWeek);
                      loadRightPanes($scope.header, $scope.selectedWeek);
                      $scope.Census.load($scope.header, $scope.selectedWeek, $scope.selectedScenario.id, Constants.ForecastMode.Scenario);
                      $scope.AttendanceProjection.load($scope.header, $scope.selectedWeek, $scope.selectedScenario.id, Constants.ForecastMode.Scenario);
                      $scope.Forecast.loadSummary($scope.header, $scope.weeks);
                  }
              });
          };

          $scope.getRoomDOWGridActions = function (activity) {
             
              var defaultActions = activity.assignee ? [UnAssignActivityAction, CancelActivityAction] : [CancelActivityAction];
              
              if (activity.recurrs !== 'Daily') {
                  var moveToOtherDayAction = [{ icon: 'general-calendar-16px.svg', name: 'Move to Other Day', value: 5 }];
                  return moveToOtherDayAction.concat(defaultActions);
              }

              return defaultActions;

          };

          $scope.getStaffDOWGridActions = function (date, availableDays, activity) {
              
              var actions = [ReturnToOriginalStaffAction, CancelActivityAction];

              if (!ActivityUtils.isStaffActivity(activity)) {
                  actions.splice(0, 0, UnAssignActivityAction);
              }

              if (activity.recurrs === 'Daily' || ActivityUtils.isStaffActivity(activity) || !availableDays || availableDays.length <= 1) {
                  return actions;
              } 

              var moveToDayList = [];
              availableDays.forEach(function (day) {

                  if (!day.date || !moment(day.date).isValid()) {
                      return;
                  }

                  if (moment(day.date).weekday() !== moment(date).weekday() && !Constants.StaffAttendTypes.isPTO(day.hours) && !Constants.StaffAttendTypes.isOff(day.hours)) {

                      var name = 'Move to ' + moment(day.date).format('dddd');

                      if (day.hours) {
                          name += '(' + day.hours + ' free)';
                      }

                      moveToDayList.push({ icon: 'general-next-day-16px.svg', name: name, date: day.date, value: 4 });
                  }
              });

              moveToDayList.push({ icon: 'general-calendar-16px.svg', name: 'Move to Other Day', value: 5 });

              return moveToDayList.concat(actions);
          };

          $scope.processRoomDOWGridAction = function (action, activity, blockHeader) {
            
              $scope.actionData = {};
              $scope.actionData.schdeleId = activity.scheduleId;
              $scope.actionData.activity = activity.activity;
              $scope.actionData.per = activity.per;
              $scope.actionData.durationUnit = activity.durationUnit;
              $scope.actionData.dayOfWeekActions = action.value;
              $scope.actionData.scenarioId = $scope.selectedScenario.id;

              var sendDOWGridAction = function () {

                  var loading = FlashService.Loading();
                  ForecastService.SetDayOfWeekActions($scope.actionData).then(function (result) {

                      if (blockHeader.roomNumber) {
                          $scope.Forecast.RoomSchedules.reloadRoomBlockHeader($scope.header, blockHeader, $scope.selectedWeek);
                      }

                      $scope.Forecast.RoomSchedules.reloadOtherActivities($scope.header, $scope.selectedWeek);
                      $scope.Forecast.RoomSchedules.loadRightPanes($scope.header, $scope.selectedWeek);
                      $scope.Forecast.StaffSchedules.reload($scope.header, $scope.selectedWeek);
                      $scope.Forecast.loadSummary($scope.header, $scope.weeks);

                      FlashService.Success(result.data);
                  }).finally(function () {
                      loading.dismiss();
                  });
              };

              switch (action.value) {
                  case (0):
                      sendDOWGridAction();
                      break;
                  case (1):
                      ForecastConfirmationService.YesNoConfirmation("Are you sure you want to cancel this activity?", null, { title: 'Cancel Activity', no: 'Never mind', yes: 'Yes, Cancel Activity' })
                                 .Yes(sendDOWGridAction)
                                 .Ask();

                      break;

                  case (5):
                      if (activity.datePlanned) {                          

                          var callback = function (result) {
                              var data = {
                                  selectedDate: moment(activity.dateSchedule).format('MM/DD/YYYY'),
                                  datePlanned: moment(activity.datePlanned).format('MM/DD/YYYY'),
                                  endDate: moment($scope.selectedWeek.endDate).format('MM/DD/YYYY'),
                                  startDate: moment($scope.selectedWeek.startDate).format('MM/DD/YYYY'),
                                  beforeLeeway: moment(activity.beforeLeeway ? moment(activity.datePlanned).add(-(activity.beforeLeeway), 'd') : moment(activity.datePlanned)).format('MM/DD/YYYY'),
                                  afterLeeway: moment(activity.afterLeeway ? moment(activity.datePlanned).add(activity.afterLeeway, 'd') : moment(activity.datePlanned)).format('MM/DD/YYYY'),
                                  staffAttendDates: result ? result.attends: null,
                                  personName: activity.assignee
                              };

                              var popup = ForecastConfirmationService.MoveToOtherDayPopup(data);

                              popup.result.then(function (data) {
                                  $scope.actionData.dateSchedule = moment(data.date.toString());
                                  $scope.actionData.dayOfWeekActions = 4;
                                  $scope.actionData.isStaffAbsent = data.staffAbsent;
                                  sendDOWGridAction();
                              });
                          };

                          var request = {
                              dateFrom: $scope.selectedWeek.startDate,
                              dateTo: $scope.selectedWeek.endDate,
                              personId: activity.assigneeId,
                              scenarioBreadcrumb: $scope.selectedScenario.id
                          };

                          $scope.Forecast.RoomSchedules.getStaffAttends(request, callback);
                      }
                      break;
              }
          };

          $scope.processStaffDOWGridAction = function (action, activity, place, blockHeader) {
              $scope.actionData = {};
              $scope.actionData.schdeleId = activity.scheduleId;
              $scope.actionData.activity = activity.activity;
              $scope.actionData.per = activity.per;
              $scope.actionData.durationUnit = activity.durationUnit;
              $scope.actionData.dayOfWeekActions = action.value;
              $scope.actionData.dateSchedule = action.date ? moment(action.date.toString()) : undefined;
              $scope.actionData.scenarioId = $scope.selectedScenario.id;

              $scope.callbackData = { reloadAssignedActivitiesPane: place === 'pane', reloadGrid: place === 'grid', blockHeader: blockHeader };

              var sendDOWGridAction = function () {

                  if ($scope.callbackData.reloadGrid) {
                      $scope.callbackData.loading = FlashService.Loading();
                  }

                  ForecastService.SetDayOfWeekActions($scope.actionData).then(function (result) {
                      if ($scope.callbackData.reloadAssignedActivitiesPane) {
                          $scope.Forecast.StaffSchedules.loadUnAssignedActivitiesPane($scope.header, $scope.selectedWeek);
                      }

                      if ($scope.callbackData.reloadGrid) {
                          $scope.callbackData.loading.dismiss();
                          $scope.Forecast.StaffSchedules.reloadStaffBlockHeader($scope.header, $scope.callbackData.blockHeader, $scope.selectedWeek);
                      }

                      $scope.Forecast.RoomSchedules.reload($scope.header, $scope.selectedWeek);
                      $scope.Forecast.loadSummary($scope.header, $scope.weeks);
                      
                      FlashService.Success(result.data);
                  });
              };

              switch (action.value) {
                  case (0):
                      $scope.callbackData.reloadAssignedActivitiesPane = true;
                      sendDOWGridAction();
                      break;
                  case (1):
                      ForecastConfirmationService.YesNoConfirmation("Are you sure you want to cancel this activity?", null, { title: 'Cancel Activity', no: 'Never mind', yes: 'Yes, Cancel Activity' })
                                 .Yes(sendDOWGridAction)
                                 .Ask();

                      break;
                  case (3):
                      var header = $scope.Forecast.StaffSchedules.getDOWHeaderByStaffName(activity.originalStaffId);
                      var dow = header.availableHours.filter(function (item) { return moment(item.date).isSame(activity.dateSchedule, 'day'); })[0];
                      
                      if (angular.isString(dow.hours) && (dow.hours.toLowerCase() === 'pto' || dow.hours.toLowerCase() === 'off')) {
                          var msg = "{0} is {1}. Cannot assign.".format(activity.originalStaff, dow.hours.toLowerCase() === 'pto' ? 'on PTO this day' : 'off this day');
                          ForecastConfirmationService.ReturnToOriginalStaffWarning(msg);
                          return;
                      }
                      
                      $scope.callbackData.reloadGrid = true;
                      $scope.callbackData.blockHeader = header;


                      sendDOWGridAction();
                      break;
                  case (4):
                      if (activity.datePlanned) {
                          var dateFrom = activity.beforeLeeway ? moment(activity.datePlanned).add(-(activity.beforeLeeway), 'd') : moment(activity.datePlanned).format('MM/DD/YYYY');
                          var dateTo = activity.afterLeeway ? moment(activity.datePlanned).add(activity.afterLeeway, 'd') : moment(activity.datePlanned).format('MM/DD/YYYY');
                          if (moment(action.date).isBefore(dateFrom, 'day') || moment(action.date).isAfter(dateTo, 'day')) {
                              var txt = "This date goes outside the scheduling leeway setup for this activity:<br><br>  {0} to {1}.<br><br> Are you sure you want to move to this day?".format(dateFrom.format('LL'), dateTo.format('LL'));
                              ForecastConfirmationService.YesNoConfirmation(txt, null, { title: 'Leeway', no: 'Never mind', yes: 'Move anyway' })
                                 .Yes(sendDOWGridAction)
                                 .Ask();
                              return;
                          }

                          sendDOWGridAction();
                      }
                      break;
                  case (5):
                      if (activity.datePlanned) {
                          var data = {
                              selectedDate: moment(activity.dateSchedule).format('MM/DD/YYYY'),
                              datePlanned: moment(activity.datePlanned).format('MM/DD/YYYY'),
                              endDate: moment($scope.selectedWeek.endDate).format('MM/DD/YYYY'),
                              startDate: moment($scope.selectedWeek.startDate).format('MM/DD/YYYY'),
                              beforeLeeway: moment(activity.beforeLeeway ? moment(activity.datePlanned).add(-(activity.beforeLeeway), 'd') : moment(activity.datePlanned)).format('MM/DD/YYYY'),
                              afterLeeway: moment(activity.afterLeeway ? moment(activity.datePlanned).add(activity.afterLeeway, 'd') : moment(activity.datePlanned)).format('MM/DD/YYYY'),
                              staffAbsenceDates: blockHeader? getStaffAbsenceDates(blockHeader) : []
                          };

                          var popup = ForecastConfirmationService.MoveToOtherDayPopup(data);

                          popup.result.then(function (data) {
                              $scope.actionData.dateSchedule = moment(data.date.toString());
                              $scope.actionData.dayOfWeekActions = 4;
                              sendDOWGridAction();
                          });
                      }
                      break;
              }

          };

          function getStaffAbsenceDates(blockHeader) {

              return blockHeader.availableHours.filter(function (dow) {
                  return !dow.present;
              }).map(function (dow) {
                  return dow.date;
              });

          }

          function initData() {

              var reloadHeader = sessionStorage.reloadHeader ? true : false;
              sessionStorage.reloadHeader = '';

              $scope.Forecast.dataLoading = true;

              ForecastService.GetForecastHeader(reloadHeader).then(function (result) {
                  $scope.header = result.data;

                  if ($scope.header.openedScenarios && $scope.header.openedScenarios.length > 0) {
                      $scope.selectedScenario = $scope.header.openedScenarios.firstOrDefault(function (scenario) {
                          return scenario.id === $scope.selectedScenarioId;
                      });

                      $scope.Forecast.setSelectedScenario($scope.selectedScenario);
                  }

                  $scope.Forecast.RoomSchedules.UnderAllocatedStaff.setFacilityAreaViewMode($scope.header.forecastOptionsSummary.forecastView);
                  $scope.Forecast.initWeekSwitcher($scope);

                  if (result.data.forecastOptionsSummary) {
                      $scope.header.selectedForecastScope = $scope.Forecast.getSelectedForecastScope($scope.header);
                          $scope.Forecast.loadSchedulesHeaders($scope.header, $scope.selectedWeek);
                          loadRightPanes($scope.header, $scope.selectedWeek);
                          $scope.Census.load($scope.header, $scope.selectedWeek, $scope.selectedScenario.id, Constants.ForecastMode.Scenario);
                      $scope.AttendanceProjection.load($scope.header, $scope.selectedWeek, $scope.selectedScenario.id, Constants.ForecastMode.Scenario);
                  }

                  loadNotes($scope.selectedScenario.id);
                  $scope.Forecast.loadSummary($scope.header, $scope.weeks);
                  $scope.Forecast.dataLoading = false;
              });

              applyRightPanelStateFromSessionStorage();
              $scope.Forecast.setSchedulingMode($scope.showRoomSchedule ? Constants.ForecastSchedulingMode.Room : Constants.ForecastSchedulingMode.Staff);
          }

          $scope.displayStaffScheduling = function () {

              if (!$scope.showStaffSchedule) {
                  $scope.showStaffSchedule = true;
				  $scope.showAnUssignedActivitiesPane = true;
                  $scope.showRoomSchedule = false;
                  $scope.showCensusProjections = false;
                  $scope.showAttendance = false;
				  $scope.showStaffInfoPane = false;
				  $scope.showBorrowResourcesPane = false;

                  if ($scope.showStaffInfoPane) {
                      $scope.showBorrowResourcesPane = false;
                      $scope.showAnUssignedActivitiesPane = false;
                  } else {

                      if ($scope.showBorrowResourcesPane) {
                          $scope.showAnUssignedActivitiesPane = false;
                      }

                      if ($scope.showAnUssignedActivitiesPane) {
                          $scope.showBorrowResourcesPane = false;
                      }

                      if (!$scope.showAnUssignedActivitiesPane && !$scope.showBorrowResourcesPane) {
                          $scope.showAnUssignedActivitiesPane = true;
                      }

                  }
                  
                  saveRightPanelStateToSessionStorage();
                  $scope.Forecast.setSchedulingMode(Constants.ForecastSchedulingMode.Staff);
                  $scope.Forecast.RoomSchedules.selectedActivityType = Constants.ForecastActivityTypes.RoomActivities;
              }
          };

          $scope.displayActivitiesForSelectedType = function (type) {

              $scope.Forecast.RoomSchedules.selectedActivityType = type;
          };

          $scope.displayRoomScheduling = function () {

              if (!$scope.showRoomSchedule) {
                  $scope.showStaffSchedule = false;
                  $scope.showRoomSchedule = true;
                  $scope.showCensusProjections = false;
                  $scope.showAttendance = false;
				  $scope.showBorrowResourcesPane = false;

                  if ($scope.showStaffInfoPane) {
                      $scope.showUnderAllocatedStaffPane = false;
                  } else {
                      $scope.showUnderAllocatedStaffPane = true;
                      $scope.showStaffInfoPane = false;
                  }

                  saveRightPanelStateToSessionStorage();
                  $scope.Forecast.setSchedulingMode(Constants.ForecastSchedulingMode.Room);
              }
          };

          $scope.displayScheduling = function () {

              confirmLocationChange(null, function () {

                  if (sessionStorage.showStaffSchedule === 'true') {
                      $scope.displayStaffScheduling();
                  }

                  if (sessionStorage.showRoomSchedule === 'true') {
                      $scope.displayRoomScheduling();
                  }

                  if (!$scope.showRoomSchedule && !$scope.showStaffSchedule) {
                      $scope.displayStaffScheduling();
                  }
              });
          };

          $scope.showattendanceReportsPane = function () {

              if (!$scope.showAttendanceReports) {
                  $scope.showAttendanceReports = true;
                  $scope.showStaffInfoPane = false;
              }
          };

          $scope.showStaffInfo = function () {
              showStaffInfoRightPane();
          };

          $scope.selectPersonInStaffInfoPane = function (personId) {
              showStaffInfoRightPane();
              $scope.StaffInfo.selectPersonInStaffInfoPane($scope.selectedWeek, personId, Constants.ForecastMode.Scenario, $scope.selectedScenario.id);
          };

          $scope.showAnUssignedActivities = function () {

              if (!$scope.showAnUssignedActivitiesPane) {
                  $scope.showAnUssignedActivitiesPane = true;
                  $scope.showBorrowResourcesPane = false;
                  $scope.showStaffInfoPane = false;
              }

              saveRightPanelStateToSessionStorage();
          };

          function showStaffInfoRightPane() {

              if (!$scope.showStaffInfoPane) {
                  $scope.showStaffInfoPane = true;
                  $scope.showBorrowResourcesPane = false;
                  $scope.showAnUssignedActivitiesPane = false;
                  $scope.showAttendanceReports = false;
                  $scope.showUnderAllocatedStaffPane = false;
              }

              saveRightPanelStateToSessionStorage();
          }

          $scope.showBorrowResources = function () {

              if (!$scope.showBorrowResourcesPane) {
                  $scope.showBorrowResourcesPane = true;
                  $scope.showStaffInfoPane = false;
                  $scope.showAnUssignedActivitiesPane = false;
				  $scope.showUnderAllocatedStaffPane = false;
              }

              saveRightPanelStateToSessionStorage();
          };

          $scope.displayAttendance = function () {

              confirmLocationChange(null, function () {
                  if (!$scope.showAttendance) {
                      $scope.showAttendance = true;
                      $scope.showCensusProjections = false;
                      $scope.showStaffSchedule = false;
                      $scope.showRoomSchedule = false;
                      $scope.showAttendanceReports = !$scope.showStaffInfoPane;
                  }
              });

          };

          $scope.showUnderAllocatedStaff = function () {
              
              if (!$scope.showUnderAllocatedStaffPane) {
                  $scope.showUnderAllocatedStaffPane = true;
                  $scope.showStaffInfoPane = false;
				  $scope.showBorrowResourcesPane = false;				  
              }

              saveRightPanelStateToSessionStorage();
          };

          $scope.displayCensusProjections = function () {

              if (!$scope.showCensusProjections) {
                  $scope.showCensusProjections = true;
                  $scope.showStaffSchedule = false;
                  $scope.showRoomSchedule = false;
                  $scope.showAttendance = false;

                  if ($scope.Forecast.isStateChanged()) {
                      $scope.Forecast.setChangedState(false);
                      $scope.Census.load($scope.header, $scope.selectedWeek, $scope.selectedScenario.id, Constants.ForecastMode.Scenario);
                  }
              }
          };

          function saveRightPanelStateToSessionStorage() {
              sessionStorage.showBorrowResourcesPane = $scope.showBorrowResourcesPane;
              sessionStorage.showUnderAllocatedStaffPane = $scope.showUnderAllocatedStaffPane;
              sessionStorage.showStaffInfoPane = $scope.showStaffInfoPane;
              sessionStorage.showAnUssignedActivitiesPane = $scope.showAnUssignedActivitiesPane;
              sessionStorage.showStaffSchedule = $scope.showStaffSchedule;
              sessionStorage.showRoomSchedule = $scope.showRoomSchedule;
          }

          function applyRightPanelStateFromSessionStorage() {
              $scope.showBorrowResourcesPane = sessionStorage.showBorrowResourcesPane === 'true';
              $scope.showStaffInfoPane = sessionStorage.showStaffInfoPane === 'true';
              $scope.showAnUssignedActivitiesPane = sessionStorage.showAnUssignedActivitiesPane === 'true';
              $scope.showRoomSchedule = sessionStorage.showRoomSchedule === 'true';
              $scope.showStaffSchedule = sessionStorage.showStaffSchedule === 'true';

              if (!$scope.showBorrowResourcesPane && !$scope.showStaffInfoPane && !$scope.showAnUssignedActivitiesPane) {
                  $scope.showAnUssignedActivitiesPane = true;
              }

              if ($scope.showRoomSchedule && !$scope.showStaffInfoPane && !$scope.showBorrowResourcesPane) {
                  $scope.showUnderAllocatedStaffPane = true;
              }

              if (!$scope.showRoomSchedule && !$scope.showStaffSchedule) {
                  $scope.showStaffSchedule = true;
              }
          }

          function loadRightPanes(header, selectedWeek) {
              $scope.Forecast.loadRightPanes($scope.header, $scope.selectedWeek);
              $scope.AttendanceReport.load($scope.header, $scope.selectedWeek, $scope.selectedScenario.id, Constants.ForecastMode.Scenario);

              var data = {
                  dateFrom: selectedWeek.startDate,
                  dateTo: selectedWeek.endDate,
                  forecastMode: Constants.ForecastMode.Scenario,
                  scenarioBreadcrumb: $scope.selectedScenario.id
              };

              ForecastService.GetStaffInfoFilter(data).then(function (result) {

                  if (result.success) {
                      $scope.StaffInfo.staffContacts = result.data.staffContacts;
                      $scope.Forecast.StaffSchedules.allTargetStaffSkills = result.data.allTargetStaffSkills;
                  }
              });
          }

          $scope.reloadAttendanceReport = function () {
              $scope.AttendanceReport.load($scope.header, $scope.selectedWeek, $scope.selectedScenario.id, Constants.ForecastMode.Scenario);
          };

          $scope.navigate = function (link) {
              $location.path(link);
          };

          $scope.navigateToScenario = function (id) {

              if (id !== $scope.selectedScenario.id) {
                  $location.path('/forecastScenario/' + id);
              }
          };

          $scope.navigateToCurrentForecast = function () {
              $location.path('currentForecast');
          };

          $scope.cancelScenario = function () {
              var data = {
                  scenarioBreadcrumb: $scope.selectedScenario.id,
                  forecastScope: $scope.header.forecastOptionsSummary.forecastScope.map(function (scope) {
                      return scope.id.trim();
                  }),
                  forecastView: $scope.header.forecastOptionsSummary.forecastView
              };

              var setScenarioCancelledStatus = function () {
                  ForecastService.CancelScenario(data).then(function (result) {
                      if (result.success) {
                          FlashService.Success($scope.selectedScenario.value + " successfully cancelled.");
                      }

                      var cancelElementIndex = $scope.header.openedScenarios.indexOf($scope.selectedScenario);
                      $scope.header.openedScenarios.splice(cancelElementIndex, 1);

                      sessionStorage.reloadHeader = true;

                      if (($scope.header.openedScenarios !== null) && ($scope.header.openedScenarios.length > 0)) {

                          $scope.navigateToScenario($scope.header.openedScenarios[0].id);
                      }
                      else {

                          $scope.navigateToCurrentForecast();
                      }
                  });
              };

              ForecastConfirmationService.YesNoConfirmation("Are you sure you want to cancel this scenario?", null, {
                  title: 'Confirm', no: 'Never mind', yes: 'Yes, cancel scenario'
              })
              .Yes(setScenarioCancelledStatus)
              .Ask();
          };

          $scope.applyScenario = function () {

              if (!$scope.header.forecastOptionsSummary.testScenariosOnly) {

                  var data = {
                      dateFrom: $scope.selectedWeek.startDate,
                      dateTo: $scope.selectedWeek.endDate,
                      forecastMode: Constants.ForecastMode.Scenario,
                      forecastView: $scope.header.forecastOptionsSummary.forecastView,
                      forecastScope: $scope.header.forecastOptionsSummary.forecastScope,
                      scenarioBreadcrumb: $scope.selectedScenario.id
                  };

                  var applyScenarioLogic = function () {
                      var loading = FlashService.Loading();

                      ForecastService.ApplyScenario(data).then(function (result) {
                          if (result.success) {
                              FlashService.Success($scope.selectedScenario.value + " successfully applied.");
                          }

                          $scope.header.openedScenarios = {};

                          sessionStorage.reloadHeader = true;

                          $scope.navigateToCurrentForecast();

                          loading.dismiss();
                      });
                  };

                  ForecastConfirmationService.YesNoConfirmation("Once a scenario is applied all other scenarios will be archived. In addition, other users will no longer be locked out of your current Forecast Scope. Are you sure you want to apply this scenario?", null, {
                      title: 'Confirm', no: 'Never mind', yes: 'Yes, apply scenario'
                  })
                  .Yes(applyScenarioLogic)
                  .Ask();
              }
          };

          $scope.openChangesList = function () {
              ScenarioChangesBridge.OpenChangesList($scope.selectedScenario,
                                                    $scope.header.forecastOptionsSummary.forecastScope,
                                                    $scope.header.forecastOptionsSummary.forecastView,
                                                    initData);
          };

          $scope.saveNotes = function () {

              var loading = FlashService.Loading();

              var data = {
                  scenarioId: $scope.selectedScenario.id,
                  scenarioNotes: $scope.notes.scenarioNotes
              };

              ForecastService.SaveScenarioNotes(data).then(function (result) {

                  loading.dismiss();

                  if (result.success) {
                      $scope.originalNotes = angular.copy($scope.notes.scenarioNotes);
                      $scope.forms.notesForm.$setPristine();
                  }
              });
          };

          $scope.cancelNotes = function () {
              $scope.notes.scenarioNotes = angular.copy($scope.originalNotes);
              $scope.forms.notesForm.$setPristine();
          };

          $scope.closeNotes = function () {
              if ($scope.forms && $scope.forms.notesForm && $scope.forms.notesForm.$dirty) {

                  var saveAndClose = function () {
                      $scope.saveNotes();
                      $scope.showNotes = false;
                  };

                  var close = function () {
                      $scope.cancelNotes();
                      $scope.showNotes = false;
                  };

                  ForecastConfirmationService.Confirmation("Save pending changes to notes?", null, {
                      title: 'Confirm', no: 'No', yes: 'Yes', cancel: 'Cancel, stay on page'
                  })
                  .Yes(saveAndClose)
                  .No(close)
                  .Ask();


              } else {
                  $scope.showNotes = false;
              }
          };

          $scope.toggleNotes = function () {

              if (!$scope.showNotes) {
                  $scope.showNotes = true;
              } else {
                  $scope.closeNotes();
              }
          };

          $scope.collapseAllCensusBlocks = function () {
              confirmLocationChange(null, $scope.Census.callapseAll);
          };

          function loadNotes(scenarioId) {
              $scope.notesLoading = true;

              ForecastService.GetScenarioNotes(scenarioId).then(function (result) {
                  $scope.notesLoading = false;

                  if (result.success) {
                      $scope.notes.scenarioNotes = result.data.scenarioNotes || '';
                      $scope.originalNotes = angular.copy($scope.notes.scenarioNotes);
                  }
              });
          }

          $scope.Forecast.attachWatchers($scope);

          $scope.StaffSchedulesDragging.onStartDraggingFromStaffBlockEvent(function () {
              $scope.showAnUssignedActivities();
          });

          $scope.StaffSchedulesDragging.onDragged(function (sourcePersonId, targetPersonId, reloadUnAssigneActivitiesPane) {

              if (sourcePersonId) {
                  var sourceHeader = $scope.Forecast.StaffSchedules.getDOWHeaderByStaffName(sourcePersonId);
                  $scope.Forecast.StaffSchedules.reloadStaffBlockHeader($scope.header, sourceHeader, $scope.selectedWeek);
              }

              if (targetPersonId) {
                  var targetHeader = $scope.Forecast.StaffSchedules.getDOWHeaderByStaffName(targetPersonId);
                  $scope.Forecast.StaffSchedules.reloadStaffBlockHeader($scope.header, targetHeader, $scope.selectedWeek);
              }

              if (reloadUnAssigneActivitiesPane && reloadUnAssigneActivitiesPane.reloadUnAssignedActivitiesTabs) {
                  $scope.Forecast.StaffSchedules.UnAssignedActivities.reloadTabs(reloadUnAssigneActivitiesPane.dates, $scope.header, $scope.Forecast.scenarioId);
              }

              $scope.Forecast.setChangedState(true);

              $scope.Forecast.RoomSchedules.reload($scope.header, $scope.selectedWeek);
              $scope.Forecast.loadSummary($scope.header, $scope.weeks);

          });

          $scope.RoomSchedulesDragging.onStartDragging(function () {
              $scope.showUnderAllocatedStaff();
          });

          $scope.RoomSchedulesDragging.onDragged(function (roomNumber) {

              var sourceHeader = $scope.Forecast.RoomSchedules.getBlockByRoomNumber(roomNumber);

              if (sourceHeader) {
                  $scope.Forecast.RoomSchedules.reloadRoomBlockHeader($scope.header, sourceHeader, $scope.selectedWeek);
              }

              $scope.Forecast.setChangedState(true);

              $scope.Forecast.RoomSchedules.loadRightPanes($scope.header, $scope.selectedWeek);
              $scope.Forecast.StaffSchedules.reload($scope.header, $scope.selectedWeek);
              $scope.Forecast.loadSummary($scope.header, $scope.weeks);
          });

          $scope.RoomSchedulesDragging.onOtherActivityDragged(function () {

              $scope.Forecast.setChangedState(true);

              $scope.Forecast.RoomSchedules.reloadOtherActivities($scope.header, $scope.selectedWeek);
              $scope.Forecast.RoomSchedules.loadRightPanes($scope.header, $scope.selectedWeek);
              $scope.Forecast.StaffSchedules.reload($scope.header, $scope.selectedWeek);
              $scope.Forecast.loadSummary($scope.header, $scope.weeks);
          });

          $scope.isDndTargetApplied = function (targetContainer, skipLimitedAccessCheck) {

              var staff = $scope.RoomSchedulesDragging.AssignStaffDraggingObject.getDraggingObject();

              if (staff && !skipLimitedAccessCheck) {

                  var hasAccess = true;

                  staff.staffDays.forEach(function (day) {
                      var date = targetContainer.date || targetContainer.dateSchedule;

                      if (moment(day.date).isSame(date, 'day')) {
                          if (day.disabled) {
                              hasAccess = false;
                          }

                          if (day.limitedAccess) {
                              var itemId = '';

                              if ($scope.header.forecastOptionsSummary.forecastView === 0) {
                                  itemId = targetContainer.blockHeader && targetContainer.blockHeader.facilityCode ? targetContainer.blockHeader.facilityCode : targetContainer.facilityGroupID;

                                  hasAccess = day.staffFacilityLimitedAccess && day.staffFacilityLimitedAccess.some(function (facility) { return facility.id === itemId; }) ||
                                      day.staffBrwFacilities && day.staffBrwFacilities.some(function (facility) { return facility.id === itemId; });
                              }

                              if ($scope.header.forecastOptionsSummary.forecastView === 1) {
                                  itemId = targetContainer.blockHeader && targetContainer.blockHeader.areaId ? targetContainer.blockHeader.areaId : targetContainer.areaGroupID;
                                  hasAccess = day.staffAreaLimitedAccess && day.staffAreaLimitedAccess.some(function (area) { return area.id === itemId; });
                              }
                          }
                      }
                  });

                  if (!hasAccess) {
                      return false;
                  }
              }

              if (targetContainer && targetContainer.dndType && targetContainer.dndType.length > 0) {

                  return targetContainer.dndType.every(function (type) {
                      return type !== 'NONE';
                  });
              }

              return false;
          };

          $scope.isActivityDraggable = function (activity) {
              return !ActivityUtils.isStaffActivity(activity);
          };

          $scope.isGroupDraggable = function (group) {

              var activities = group.getActivities();

              return !activities.some(function (activity) {
                  return ActivityUtils.isStaffActivity(activity);
              });
          };

          initData();

          $scope.isLeftMenuOpened = function () {
              return $rootScope.leftMenuIsOpened;
          };

          function confirmLocationChange(newUrl, func) {
              if (!$scope.Census.form || !$scope.Census.form.$dirty) {
                  if (func) {
                      func();
                  }

                  return;
              }

              var resumeLocationChangeStart = function () {
                  $scope.Census.form.$setPristine();

                  if (newUrl) {
                      $location.path(newUrl);
                  }

                  if (func) {
                      func();
                  }
              };

              var continueWithoutSaving = function () {

                  if (newUrl) {
                      resumeLocationChangeStart();
                  } else {
                      $scope.Census.callapseAll();

                      if (func) {
                          func();
                      }
                  }

              };

              var isLeftMenuOpened = $rootScope.leftMenuIsOpened;

              var leaveMenuOpenedIfItWas = function () {

                  if (isLeftMenuOpened) {
                      $rootScope.showMenu();
                  }
              };

              var continueWithSave = function () {
                  $q.when($scope.Census.getCensusProjectionAndSave($scope.selectedScenario.id, $scope.selectedWeek)).then(function () {
                      resumeLocationChangeStart();
                  });
              };

              ForecastConfirmationService.Confirmation("There are unsaved changes to census projections. Save pending changes?", null, { yes: 'Yes, save and continue', no: 'No, continue without saving ', cancel: 'Cancel, stay on page' })
                                 .Yes(continueWithSave)
                                 .No(continueWithoutSaving)
                                 .Cancel(leaveMenuOpenedIfItWas)
                                 .Ask();
          }

          $scope.$on('$locationChangeStart', function (event, newUrl) {
              if ($scope.Census.form && $scope.Census.form.$dirty) {
                  event.preventDefault(newUrl);
                  confirmLocationChange($location.path());
              }
          });

          window.addEventListener("beforeunload", function (e) {
              if ($scope.Census.form && $scope.Census.form.$dirty) {
                  var confirmationMessage = "";
                  (e || window.event).returnValue = confirmationMessage;
                  return confirmationMessage;
              }
          });

      }]);